import { v4 as uuidv4 } from "uuid";
import Cookie from "js-cookie";

const gSession = {};

export function getSessionId() {
  if (!gSession.sessionId) {
    let sessionId = window.localStorage.getItem("tts-session-id");
    if (!sessionId) {
      // NOTE: it might not be the best design security-wise to allow ids to be generated on client-side
      // but, I don't really think something more complicated is necessary at the moment
      sessionId = uuidv4();
      window.localStorage.setItem("tts-session-id", sessionId);
      console.log("setting session id to: " + sessionId);
    } else {
      console.log("loaded existing session id: " + sessionId);
    }
    gSession.sessionId = sessionId;
  }
  return gSession.sessionId;
}

export function goTo(loc) {
  window.location.href = loc;
  return null;
}

export function goToDashboard() {
  return goTo("/dashboard");
}
// The Studio has no login of its own — the website owns sign-in and writes the
// shared auth cookie, which the Studio only reads. So logout has to return the
// user to the login page of the website that talks to the SAME API.
//
// Sending a dev user to the production login page issues a token signed with the
// production JWT secret. Because both environments share one cookie on
// .waterscenterst.org, that token lands in dev and every authenticated call
// fails with "invalid signature" — a token that is present and unexpired but
// unverifiable, so it reads as 401 rather than a login prompt.
//
// Resolved at runtime from the hostname: webpack injects no environment config
// into this bundle, and the deployed artifact is a static build served by nginx.
// Unrecognized hosts (including localhost) fall through to production, which is
// the behavior this file has always had.
const LOGIN_URLS = {
  "thinkingtoolsstudiodev.waterscenterst.org": "https://dev.waterscenterst.org/login",
  "ttsdevtest.azurewebsites.net": "https://dev.waterscenterst.org/login",
};

const PRODUCTION_LOGIN_URL = "https://waterscenterst.org/login";

export function getLoginUrl() {
  if (typeof window === "undefined") return PRODUCTION_LOGIN_URL;
  return LOGIN_URLS[window.location.hostname] || PRODUCTION_LOGIN_URL;
}

export function goToLogin() {
  return goTo(getLoginUrl());
}

export function getSessionAuth() {
  if (!gSession.auth) {
    const sessAuth = Cookie.get("jt");

    gSession.auth = !!sessAuth;
    gSession.user = !!sessAuth;
    gSession.accessToken = sessAuth;
  }

  return gSession;
}

export function sessionLogout() {
  const sessionId = window.localStorage.getItem("tts-session-id");
  const cookie = Cookie.get("jt");

  if (sessionId && cookie) {
    window.localStorage.clear("tts-session-id", sessionId);
    Cookie.remove("jt", { domain: ".waterscenterst.org" });
    goToLogin();
  }
}
